<div class="payment-method-description-container flex justify-center items-center w-full mt-4 mb-6">
  <p class="payment-method-description md:text-lg lg:text-lg xl:text-md w-3/5 text-center">
    Please enter the voucher number and your mobile number
  </p>
</div>


<div class="gray-box-container bg-gray-300 flex justify-center items-center w-full p-3 min-h-100 sm:p-8 sm:h-80" style="border-radius: 12px;" [class]="walletClass">
  <mat-spinner *ngIf="loading"
               class="loading-spinner"
               [color]="color"
               [diameter]="diameter"
  >
  </mat-spinner>

  <div class="form-container w-full" *ngIf="!loading">
    <form [formGroup]="applicationDetailsForm" class="flex flex-wrap flex-row items-center justify-evenly">

      <mat-form-field appearance="standard" class="w-11/12 sm:w-2/5 relative">
        <mat-label>Voucher Number</mat-label>
        <input matInput placeholder="00000000000000" [formControl]="voucherNumber" required>
        <mat-error *ngIf="voucherNumber.hasError('required')">Voucher number is required</mat-error>
        <mat-error *ngIf="voucherNumber.hasError('validationFailed')">{{validationErrorMessage}}</mat-error>
      </mat-form-field>

      <!-- <mat-form-field appearance="fill" class="w:12"></mat-form-field> -->

      <mat-form-field appearance="standard" class="w-11/12 sm:w-2/5 relative">
        <mat-label>Mobile Number</mat-label>
        <input matInput placeholder="082 000 0000" [formControl]="mobileNumber" required>
        <mat-error *ngIf="mobileNumber.hasError('required')">Mobile number is required</mat-error>
      </mat-form-field>

    </form>
  </div>
  <div class="button-container w-full flex justify-center" *ngIf="!loading">
    <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1' : 'mr-4 mb-4'">
      <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button pl-12 pr-12 flex items-center mt-2" [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
        <p class="p-0 m-0">CANCEL</p>
      </button>
    </div>
    <div class="flex justify-center items-center flex-col confirm-container">
      <button class="text-lg text-white h-12 mt-2 rounded-lg w-48" [ngStyle]="{'background-color': headerColor}" (click)="initiateVoucherTransaction()" [ngClass]="mobile ? 'mr-0 mb-1' : 'mb-4'">
        <strong>CONTINUE</strong>
      </button>
    </div>
  </div>
</div>
